module.exports = __webpack_public_path__ + "img/068.4d274e6f.jpg";